import { skipToken } from '@reduxjs/toolkit/query';
import { BlankScreen } from '@strata/react-page-templates';
import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router';

import { AppRoutes } from 'services/routes';
import { MESSAGES_LOCATION_HASH } from 'services/userSupportHelpers';
import { useGetConversationByDisplayIdQuery } from 'store/api/userSupportChatApi';

export const ConversationRedirect = () => {
    const { displayId } = useParams();
    const navigate = useNavigate();
    const {
        data: conversation,
        isSuccess,
        isError,
    } = useGetConversationByDisplayIdQuery(displayId ?? skipToken);

    useEffect(() => {
        if (conversation?.referralId) {
            navigate(
                {
                    pathname: AppRoutes.referralRedirect(conversation.referralId),
                    hash: MESSAGES_LOCATION_HASH,
                },
                {
                    replace: true,
                    state: { conversationId: conversation.conversationId },
                },
            );
            return;
        }
        if (!displayId || isSuccess || isError) {
            navigate(AppRoutes.allMessages);
        }
    }, [conversation, displayId, isError, isSuccess, navigate]);

    return <BlankScreen />;
};
